import { render } from "./EditStockInView.vue?vue&type=template&id=61f6397f"
import script from "./EditStockInView.vue?vue&type=script&lang=js"
export * from "./EditStockInView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__